/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton, Chip, FormControl, Checkbox, FormHelperText, Grid } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Service';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types'
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@mui/material/styles';
import xlsx from 'json-as-xlsx';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import dayjs from 'dayjs';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "FINALSTATUSOFSUPLIERPAYMENTREPORT"

export default function FinalStatusofSuplierPaymentReport() {
    const componentRef = useRef();
    const navigate = useNavigate();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Supplier Payment Status Report'
    });
    const [fromDatevalue, setFromDateValue] = useState(new Date());
    const [toDatevalue, setToDateValue] = useState(new Date());
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [reportDetails, setReportDetails] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [grnData, setgrnData] = useState({
        grnName: ''
    });
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [formData, setFormData] = useState({
        groupID: '',
        operationEntityID: '',
        approveStatusID: '0',
        isReinitiate: '0',
        paymentStatusID: '0',
        fromDate: null,
        toDate: null
    });
    const [totalCals, setTotalCals] = useState(0);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '',
        operationEntityName: '',
        fromDate: '',
        toDate: ''
    });
    const [selectedOptions, setSelectedOptions] = useState([]);
    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const classes = useStyles();
    const supplierVerificationReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.array()
            .min("1", 'Please select at least one Fresh collection center')
            .required('Please select at least one Fresh collection center'),
    });
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            approveStatusID: formData.approveStatusID,
            paymentStatusID: formData.paymentStatusID,
            isReinitiate: formData.isReinitiate,
            fromDate: fromDatevalue,
            toDate: toDatevalue,
        },

        validationSchema: supplierVerificationReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
            setIsHidden(true)
        }
    });

    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            approveStatusID: parseInt(values.approveStatusID),
            paymentStatusID: parseInt(values.paymentStatusID),
            isReinitiate: parseInt(values.isReinitiate),
            fromDate: new Date(fromDatevalue).toISOString().split('T')[0],
            toDate: new Date(toDatevalue).toISOString().split('T')[0],
        }
        var res = await services.GetFinalStatusofSuplierPaymentReport(model)
        const total = res.reduce((accumulator, current) => accumulator + current.amount, 0);

        setTotalCals(total)
        setPage(0);
        setReportDetails(res);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (permissionList.isFactoryFilterEnabled) {
            setFromDateValue(new Date());
            setToDateValue(new Date());
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
                factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
                approveStatusID: 0,
                paymentStatusID: 0,
                isReinitiate: 0,
                fromDatevalue: fromDatevalue.toISOString().split('T')[0],
                toDatevalue: toDatevalue.toISOString().split('T')[0],
            })
            setReportDetails([]);
            setSelectedOptions([]);
            setSelectedProductOptions([]);
        } else {
            setReportDetails([]);
        }
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    function getSelectedDropdownValuesForReport() {
        var grpname
        {
            group.map((x) => (
                x.groupID == formik.values.groupID ? grpname = x.groupName : null
            ))
        }
        var operationentityname
        {
            factory.map((x) => (
                x.factoryID == formik.values.operationEntityID ? operationentityname = x.factoryName : null
            ))
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
        var newOptionArray = [];
        for (var i = 0; i < res.length; i++) {
            newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
        }
        setOperationEntityList(newOptionArray);
    }

    useEffect(() => {
        trackPromise(GetRouteByFactoryID());
    }, [formik.values.operationEntityID]);

    useEffect(() => {
    }, [formik.values.collectionCenterID]);

    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        GetAllGroups();
    }, []);
    useEffect(() => {
        setReportDetails([]);
    }, [formik.values.groupID, formik.values.operationEntityID, formik.values.approveStatusID, formik.values.paymentStatusID, formik.values.isReinitiate])

    useEffect(() => {
        setReportDetails([]);
    }, [fromDatevalue, toDatevalue]);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setReportDetails([]);
        setFromDateValue(new Date())
        setToDateValue(new Date())
    }, [selectedOptions, selectedProductOptions]);

    useEffect(() => {
        setSelectedOptions([]);
        setFromDateValue(new Date())
        setToDateValue(new Date())
    }, [formik.values.groupID]);

    useEffect(() => {
        setValues({
            ...values,
            approveStatusID: 0,
            isReinitiate: 0,
            paymentStatusID: 0,
        });
    }, [formik.values.groupID, selectedOptions, toDatevalue, fromDatevalue]);


    useEffect(() => {
        setValues({
            ...values,
            isReinitiate: 0,
            paymentStatusID: 0,
        });
    }, [formik.values.approveStatusID]);

    useEffect(() => {
        setValues({
            ...values,
            isReinitiate: 0,
        });
    }, [formik.values.paymentStatusID]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions,
        })
    }, [selectedOptions, selectedProductOptions]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [operationEntityList]);


    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - reportDetails.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSelectChange = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedOptions(
                selectedOptions.length === operationEntityList.length
                    ? []
                    : operationEntityList.map((option) => option.value)
            );
        } else {
            setSelectedOptions(selectedValues);
        };
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFINALSTATUSOFSUPLIERPAYMENTREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
    }

    async function GetRouteByFactoryID() {
        var res = await services.GetRouteByFactoryID(formik.values.operationEntityID)
        if (res != null) {
            setRoute(res);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(reportDetails);

        var settings = {
            sheetName: 'SPV Report',
            fileName: 'Supplier Payment Status Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'SPV Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'FCC Name': x.factoryName,
                    'FCC Code': x.factoryCode,
                    'GRN Number': x.grnNumber,
                    'GRN Date': moment(x.goodsRecieveDate).format("YYYY-MM-DD"),
                    'Supplier Code': x.farmerCode,
                    'Supplier Name': x.accountName,
                    'Amount': parseFloat(x.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Approval Status': x.approvalStatus == 1 ? "New"
                        : x.approvalStatus == 2 ? "FDC First Approved"
                            : x.approvalStatus == 3 ? "FDC Second Approved"
                                : x.approvalStatus == 4 ? "Finance First Approved"
                                    : x.approvalStatus == 5 ? "Finance Second Approved"
                                        : x.approvalStatus == 6 ? "FDC First Rejected"
                                            : x.approvalStatus == 7 ? "FDC Second Rejected"
                                                : x.approvalStatus == 8 ? "Finance First Rejected"
                                                    : x.approvalStatus == 9 ? "Finance Second Rejected"
                                                        : "Active",
                    'Payment Status': x.approvalStatus == 5 ? "Approved" :
                        x.approvalStatus == 6 || x.approvalStatus == 7 || x.approvalStatus == 8 || x.approvalStatus == 9 ? "Rejected" : "Pending",
                    'Payment Posting Date': x.paymentPostingDate == '0001-01-01T00:00:00' ? '-' : moment(x.paymentPostingDate).format("YYYY-MM-DD"),
                    'Is Renitiate': x.isReinitiste == true ? 'True' : 'False',
                    'Reinitiate Date': x.formattedReInitiateDate,
                }
                res.push(vr);
            });
            var vr2 = {
                'FCC Name': 'Total',
                'Amount': parseFloat(totalCals).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }
            res.push(vr2);
        }
        return res;
    }


    function getSelectedDropdownValuesForReport() {
        let groups = groupList.find(x => x.groupID == formik.values.groupID)
        const facName = [];
        const proName = [];
        selectedOptions.forEach(x => {
            const fildered = operationEntityList.find(y => x === y.value).label
            facName.push(fildered)
        });
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: groups.groupName,
            operationEntityName: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(','),
            fromDate: new Date(fromDatevalue).toISOString().split('T')[0],
            toDate: new Date(toDatevalue).toISOString().split('T')[0],
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = operationEntityList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Supplier Payment Status Report  |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            value={formik.values.groupID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('groupID')}
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>Select Group</MenuItem>
                                            {groupList.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                            <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                            <Select
                                                className="custom-select"
                                                labelId="multi-select-label"
                                                id="multi-select"
                                                multiple
                                                size="small"
                                                value={selectedOptions}
                                                onChange={handleSelectChange}
                                                label="Fresh Collection Center "
                                                disabled={!permissionList.isFactoryFilterEnabled}
                                                renderValue={(selected) => renderSelectedValue(selected)}
                                            >
                                                <MenuItem key={0} value={''}>
                                                    <Checkbox checked={selectedOptions.length === operationEntityList.length} color="primary" />
                                                    All Fresh Collection Center
                                                </MenuItem>
                                                {operationEntityList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {touched.operationEntityID && errors.operationEntityID && (
                                                <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                            )}
                                            {selectedOptions.length > 0 && (
                                                <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                    {!permissionList.isFactoryFilterEnabled ? null :
                                                        <ClearIcon />}
                                                </IconButton>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                fullWidth
                                                size="small"
                                                label="GRN Complete From Date *"
                                                openTo="day"
                                                type="date"
                                                inputFormat="MM/DD/YYYY"
                                                value={fromDatevalue}
                                                onChange={(newValue) => {
                                                    setFromDateValue(newValue);
                                                }}
                                                maxDate={dayjs()}
                                                renderInput={(params) => (
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...params}
                                                    />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                fullWidth
                                                size="small"
                                                label="GRN Complete To Date *"
                                                openTo="day"
                                                type="date"
                                                inputFormat="MM/DD/YYYY"
                                                value={toDatevalue}
                                                onChange={(newValue) => {
                                                    setToDateValue(newValue);
                                                }}
                                                maxDate={dayjs()}
                                                renderInput={(params) => (
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...params}
                                                    />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Approve Status "
                                            value={formik.values.approveStatusID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('approveStatusID')}
                                            error={Boolean(touched.approveStatusID && errors.approveStatusID)}
                                            helperText={touched.approveStatusID && errors.approveStatusID}
                                        >
                                            <MenuItem key={0} value={0}>All Status</MenuItem>
                                            <MenuItem value={1}> New</MenuItem>
                                            <MenuItem value={2}> FDC First Approved</MenuItem>
                                            <MenuItem value={3}> FDC Second Approved</MenuItem>
                                            <MenuItem value={4}> Finance First Approved</MenuItem>
                                            <MenuItem value={5}> Finance Second Approved</MenuItem>
                                            <MenuItem value={6}> FDC First Rejected</MenuItem>
                                            <MenuItem value={7}> FDC Second Rejected</MenuItem>
                                            <MenuItem value={8}> Finance First Rejected</MenuItem>
                                            <MenuItem value={9}> Finance Second Rejected</MenuItem>
                                        </TextField>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Payment Status "
                                            value={formik.values.paymentStatusID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('paymentStatusID')}
                                            error={Boolean(touched.paymentStatusID && errors.paymentStatusID)}
                                            helperText={touched.paymentStatusID && errors.paymentStatusID}
                                        >
                                            <MenuItem key={0} value={0}>All Status</MenuItem>
                                            <MenuItem value={1}> Approved</MenuItem>
                                            <MenuItem value={2}> Pending</MenuItem>
                                            <MenuItem value={3}> Rejected</MenuItem>
                                        </TextField>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Is Reinitiate"
                                            value={formik.values.isReinitiate}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('isReinitiate')}
                                            error={Boolean(touched.isReinitiate && errors.isReinitiate)}
                                            helperText={touched.isReinitiate && errors.isReinitiate}
                                        >
                                            <MenuItem key={0} value={0}>All Status</MenuItem>
                                            <MenuItem value={1}>True</MenuItem>
                                            <MenuItem value={2}>False</MenuItem>
                                        </TextField>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="error"
                                                onClick={() => clearAll()}
                                                style={{ marginRight: '10px' }} // Added marginRight for spacing
                                            >
                                                Clear
                                            </Button>
                                            <Button
                                                type="submit"
                                                color="secondary"
                                                variant="outlined"
                                            >
                                                Search
                                            </Button>
                                        </Grid>
                                </Grid>
                                </Stack>
                            </Stack>
                            <br />
                            {isEnable == false ?
                                <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginBottom: '10px' }} justifyContent="right" spacing={2}>
                                    <TextField
                                        size="small"
                                        style={{ width: '300px' }}
                                        value={grnData.grnName}
                                        placeholder="Search"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Stack> : null}
                            {reportDetails.length != 0 ?
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Card style={{ justifycontent: 'center', width: '120rem' }} >
                                        <TableContainer component={Paper} >
                                            <Table aria-label="simple table" size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left">FCC Name</TableCell>
                                                        <TableCell align="left">FCC Code</TableCell>
                                                        <TableCell align="left">GRN Number</TableCell>
                                                        <TableCell align='left'>GRN Date</TableCell>
                                                        <TableCell align="left">Supplier Code</TableCell>
                                                        <TableCell align="left">Supplier Name</TableCell>
                                                        <TableCell align="right">Amount</TableCell>
                                                        <TableCell align="left">Approval Status</TableCell>
                                                        <TableCell align="left">Payment Status</TableCell>
                                                        <TableCell align="left">Payment Posting Date</TableCell>
                                                        <TableCell align="left">Is Renitiate</TableCell>
                                                        <TableCell align="left">Reinitiate Date</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(rowsPerPage > 0
                                                        ? reportDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        : reportDetails
                                                    ).map((row) => {
                                                        return (
                                                            <TableRow key={row.grnNumber}>
                                                                <TableCell align="left">{row.factoryName}</TableCell>
                                                                <TableCell align="left">{row.factoryCode}</TableCell>
                                                                <TableCell align="left">{row.grnNumber}</TableCell>
                                                                <TableCell align="left">{moment(new Date(row.goodsRecieveDate)).format('YYYY-MM-DD')}</TableCell>
                                                                <TableCell align="left">{row.farmerCode}</TableCell>
                                                                <TableCell align="left">{row.accountName}</TableCell>
                                                                <TableCell align="right">{parseFloat(row.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                <TableCell align="left">
                                                                    {row.approvalStatus == 1 ? <Chip size="small" label="New" style={{ color: 'green' }} />
                                                                        : row.approvalStatus == 2 ? <Chip size="small" label="FDC First Approved" style={{ color: 'orange' }} />
                                                                            : row.approvalStatus == 3 ? <Chip size="small" label="FDC Second Approved" style={{ color: '#B414F9' }} />
                                                                                : row.approvalStatus == 4 ? <Chip size="small" label="Finance First Approved" style={{ color: 'blue' }} />
                                                                                    : row.approvalStatus == 5 ? <Chip size="small" label="Finance Second Approved" style={{ color: 'blue' }} />
                                                                                        : row.approvalStatus == 6 ? <Chip size="small" label="FDC First Rejected" style={{ color: 'red' }} />
                                                                                            : row.approvalStatus == 7 ? <Chip size="small" label="FDC Second Rejected" style={{ color: 'red' }} />
                                                                                                : row.approvalStatus == 8 ? <Chip size="small" label="Finance First Rejected" style={{ color: 'red' }} />
                                                                                                    : row.approvalStatus == 9 ? <Chip size="small" label="Finance Second Rejected" style={{ color: 'red' }} />
                                                                                                        : <Chip size="small" label="Active" style={{ color: 'green' }} />}
                                                                </TableCell>
                                                                <TableCell align="left">{row.approvalStatus == 5 ? "Approved" :
                                                                    row.approvalStatus == 6 || row.approvalStatus == 7 || row.approvalStatus == 8 || row.approvalStatus == 9 ? "Rejected" : "Pending"}</TableCell>
                                                                <TableCell align="left">{row.paymentPostingDate == '0001-01-01T00:00:00' ? '-' : moment(new Date(row.paymentPostingDate)).format('YYYY-MM-DD')}</TableCell>
                                                                <TableCell align="left">{row.isReinitiste == true ? 'True' : 'False'}</TableCell>
                                                                <TableCell align="left">{row.formattedReInitiateDate}</TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                    {emptyRows > 0 && (
                                                        <TableRow style={{ height: 53 * emptyRows }}>
                                                            <TableCell colSpan={20} />
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                                <TableRow>
                                                    <TableCell align="left"><b>Total</b></TableCell>
                                                    <TableCell colSpan={5} />
                                                    <TableCell align="right"><b>{parseFloat(totalCals).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                                    <TableCell colSpan={9} />
                                                </TableRow>
                                            </Table>
                                        </TableContainer>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                            count={reportDetails.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            SelectProps={{
                                                inputProps: {
                                                    'aria-label': 'rows per page',
                                                },
                                                native: true,
                                            }}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActions}
                                        />
                                    </Card>
                                </Stack> : <SearchNotFound searchQuery="Supplier Payment Status Report" />}
                        </Form>
                    </FormikProvider>
                    {reportDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Supplier Payment Verification Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    reportDetails={reportDetails}
                                    searchData={selectedSearchValues}
                                    totalCals={totalCals}
                                />
                            </div>
                        </Box>
                        : null}
                </Container>
            </Page>
        </>
    );
}
